import React from 'react';
import PropTypes from 'prop-types';

import {AuthoringSupplementModelV1} from 'resources/augmented/AuthoringSupplement/AuthoringSupplementModel.v1';
import {SupplementModelV1} from 'resources/augmented/Supplement/SupplementModel.v1';
import {getCroppedImageUrl} from 'client/SupplementTypes/Image/utils';

export default class ImageRenderer extends React.Component {
  // eslint-disable-next-line react/sort-comp
  willUnmountHasFired = false;

  static propTypes = {
    onClick: PropTypes.func,
    supplement: PropTypes.oneOfType([
      PropTypes.instanceOf(AuthoringSupplementModelV1),
      PropTypes.instanceOf(SupplementModelV1)
    ]).isRequired,
    className: PropTypes.string
  };

  static defaultProps = {
    onClick: () => {}
  };

  constructor(props) {
    super(props);
    this.state = {};
    const {supplement} = props;
    /**
     * The SupplementStore that provides the supplement can still be resolving information...
     */
    const {path} = supplement.getImageLocation();
    if (!path) {
      return;
    }

    /**
     * If there is no crop information for the supplement, we can render it as-is
     * without making a request for metadata.
     */
    if (supplement.getCropValues().isEmpty()) {
      this.state.src = supplement.getImageLocation().href;
    }
  }

  componentDidMount() {
    /**
     * The SupplementStore that provides the supplement can still be resolving information...
     */
    const {path} = this.props.supplement.getImageLocation();
    if (!path || this.state.src) {
      return;
    }
    this.fetchImageSrc();
  }

  componentDidUpdate(prevProps) {
    if (prevProps.supplement !== this.props.supplement) {
      this.fetchImageSrc();
    }
  }

  componentWillUnmount() {
    this.willUnmountHasFired = true;
  }

  /**
   * "Fecth" the `src` for the image based on the properties of the supplment.
   */
  fetchImageSrc() {
    // If the image is not cropped then it can be retrieved from the supplements CDN
    if (this.props.supplement.getCropValues().isEmpty()) {
      const src = this.props.supplement.getImageLocation().href;
      this.setState({src});
      return;
    }

    // If the image is cropped then it needs to be transformed and retrieved through the imgproxy service
    getCroppedImageUrl(this.props.supplement).then((src) => {
      if (this.willUnmountHasFired) {
        return;
      }
      this.setState({src});
    });
  }

  preventDefault(e) {
    e.preventDefault();
  }

  render() {
    const {className} = this.props;
    /**
     * Wait for a lifecycle to resolve `fetchImageSrc`
     */
    if (!this.state.src) {
      return null;
    }

    return (
      <img
        className={className}
        src={this.state.src}
        alt={this.props.supplement.getAlttext()}
        onContextMenu={this.preventDefault}
        onClick={this.props.onClick}
      />
    );
  }
}
